<button
  click-stop-propagation
  class="adap-btn-grid-cell"
  type="button"
  (click)="deleteClick()"
  matTooltip="delete"
  matTooltipPosition="above"
>
  <mat-icon svgIcon="cvx-trash"></mat-icon>
</button>
